import { useQuery } from "@tanstack/react-query";
import { getProfile, getAllUsers, getAllAdmins, getKycDocs, getalldepositReq, getallwithdrawReq, getAllReferrals, getAllLoanAgreements } from "../superAdminApis"; 
// Hook to fetch all users


// get profile hook 
const useProfile = () => {
  return useQuery({
    queryFn: getProfile,
    queryKey: ["profile"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};

const useAllUsers = () => {
  return useQuery({
    queryFn: getAllUsers,
    queryKey: ["allUsers"],
    staleTime: 1000 * 60 * 10, // Cache for 10 minutes
  });
};

const useAllAdmins = () => {
  return useQuery({
    queryFn: getAllAdmins,
    queryKey: ["allAdmins"],
    staleTime: 1000 * 60 * 10, // Cache for 10 minutes
  });
};

const useAllKycDoc = () => {
  return useQuery({
    queryFn: getKycDocs,
    queryKey: ["allKycDocs"],
    staleTime: 1000 * 60 * 10, // Cache for 10 minutes
  });
};

const useAllDepositRequests = () => {
  return useQuery({
    queryFn: getalldepositReq,
    queryKey: ["allDepositRequests"],
    staleTime: 1000 * 60 * 10, // Cache for 10 minutes
  });
};


const useAllWithdrawRequests = () => {
  return useQuery({
    queryFn: getallwithdrawReq,
    queryKey: ["allWithdrawRequests"],
    staleTime: 1000 * 60 * 10, // Cache for 10 minutes
  });
};

// Hook to get all referrals
const useAllReferrals = () => {
  return useQuery({
    queryFn: getAllReferrals,
    queryKey: ["allReferrals"],
    staleTime: 1000 * 60 * 10, // Cache for 10 minutes
  });
};

// Hook to get all loan agreements
const useAllLoanAgreements = () => {
  return useQuery({
    queryFn: getAllLoanAgreements,
    queryKey: ["allLoanAgreements"],
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};

export { useProfile, useAllUsers, useAllAdmins, useAllKycDoc, useAllDepositRequests, useAllWithdrawRequests, useAllReferrals, useAllLoanAgreements };